import { Control, Controller } from 'react-hook-form';
import { Pressable, TextInput, View } from 'react-native';
import { Text } from '@/components/Text';
import { Icon } from '@/components/Icon';
import colors, { appTheme } from '@/config/colors';
import { styles } from './styles';

interface DigaCodeInputProps {
  control: Control<{ digaCode: string }>;
  getBorderStyle: (digaCode: string) =>
    | {
        borderBottomWidth: number;
        borderBottomColor: string;
      }
    | {};
  digaCharacters: (value: string) => boolean;
  responsiveStyles: { [key: string]: object };
  handleSubmit: (onSubmit: (data: any) => void) => () => void;
  onSubmit: (data: any) => void;
  isSecondDigaCodeInput?: boolean;
  isError: boolean;
  label: string;
  description?: string;
}

export const DigaCodeInput = ({
  control,
  digaCharacters,
  getBorderStyle,
  responsiveStyles,
  handleSubmit,
  onSubmit,
  isError,
  isSecondDigaCodeInput = false,
  label,
  description,
}: DigaCodeInputProps) => {
  const formatDigaCode = (code: string) => {
    return code
      .toUpperCase()
      .replace('0', 'O')
      .replace(/[^2-7A-Z]/g, '');
  };

  return (
    <View style={styles.cardContainer}>
      <Text style={styles.cardLabel}>{label}</Text>
      {description ? (
        <Text style={styles.secondInfoText}>{description}</Text>
      ) : null}
      <View style={styles.inputBoxContainer}>
        <Controller
          control={control}
          name="digaCode"
          rules={{
            required: true,
            validate: (value) => digaCharacters(value),
          }}
          render={({ field: { onChange, value, onBlur } }) => (
            <TextInput
              autoCapitalize={'characters'}
              autoComplete={'off'}
              onBlur={onBlur}
              onChangeText={(value) => onChange(formatDigaCode(value))}
              maxLength={16}
              style={[styles.inputBox, styles.inputText, getBorderStyle(value)]}
              value={value}
            />
          )}
        />
        <Pressable
          style={[
            responsiveStyles.buttonStyle,
            responsiveStyles.buttonTitleStyle,
            { backgroundColor: appTheme.primary },
          ]}
          onPress={handleSubmit(onSubmit)}
        >
          <Text className="text-xl text-bold text-center text-white">
            {isSecondDigaCodeInput ? 'Vorplanen' : 'Einlösen'}
          </Text>
        </Pressable>
      </View>
      {isError ? (
        <View style={styles.formatWarning}>
          <Icon name="alertTriangle" size={22} color={colors.yellow} />
          <Text style={styles.secondInfoText}>
            16 Zeichen, ohne Bindestriche, Leerzeichen und Kleinbuchstaben. Die
            Ziffer 0 wird durch O ersetzt.
          </Text>
        </View>
      ) : null}
    </View>
  );
};
